
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30688',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30688",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55188",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8257",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11713",
  "I18n": "static-7.1656",
  "quartz": "static-1.7342",
  "quartz-config": "static-1.1120",
  "quartz-core": "static-1.6561",
  "react-dlb": "static-1.84",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.75",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.863",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55175",
  "feedback-utils": "static-1.55179",
  "forms-embed-utils-lib": "static-1.4697",
  "forms-utils-lib": "static-1.12995",
  "foundations-assets": "static-1.5107",
  "foundations-components": "static-1.8359",
  "foundations-theming": "static-1.4685",
  "hub-http": "static-1.6445",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12020",
  "icons": "static-2.673",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4080",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16939",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5503",
  "react-virtualized": "static-2.103",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.492",
  "tinymce-plugins": "static-1.58080",
  "transmute": "static-2.85",
  "ui-images": "static-2.1224",
  "UIComponents": "static-3.8659",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3563",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3619",
  "quartz-webpack": "static-1.3566",
  "foundations-theming-specialty": "static-1.2401",
  "property-description-translator": "static-1.4070",
  "HeadJS": "static-2.786",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3368",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4550",
  "jasmine-runner": "static-1.6680",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.864",
  "hubspotter-http": "static-1.4812",
  "mobile-manifest-mixins": "static-1.561",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1017",
  "quartz-head": "static-1.1007",
  "quartz-i18n": "static-1.1017",
  "quartz-routing": "static-1.772",
  "quartz-test": "static-1.1017",
  "quartz-tracking": "static-1.721",
  "trellis-components": "static-1.2438",
  "ui-fonts": "static-1.975",
  "usage-tracker-container": "static-1.7579",
  "usage-tracker-core": "static-1.7439",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7481",
  "reference-resolvers": "static-1.8414",
  "sanitize-text": "static-1.8381",
  "PatternValidationJS": "static-1.3128",
  "ReduxMessenger": "static-2.10597",
  "sanitize": "static-1.4708",
  "outpost": "static-1.4394",
  "rpc-client-utils": "static-1.4894",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4628",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9658",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.56",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2419",
  "bend-plugin-foundations-theming": "static-1.3168",
  "foundations-theming-base": "static-1.3670",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.244",
  "csstype": "static-1.50",
  "web-vitals": "static-1.10",
  "ai-components-ui-library": "static-1.9546",
  "atom": "static-1.5308",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8109",
  "ContentUtils": "static-1.69021",
  "data-token-picker": "static-1.16793",
  "file-manager-components": "static-1.24316",
  "FileManagerCore": "static-1.39815",
  "FileManagerLib": "static-1.39956",
  "frontend-preferences-client": "static-1.8160",
  "hub-http-contrib": "static-1.3271",
  "interframe": "static-3.4987",
  "layout-dnd-components": "static-1.12867",
  "layout-dnd-utils": "static-1.11842",
  "property-translator": "static-1.5626",
  "react-codemirror": "static-1.10872",
  "react-colorpicker": "static-2.10439",
  "reference-resolvers-lite": "static-1.8331",
  "rich-text-lib": "static-1.20212",
  "tinymce-data": "static-1.41051",
  "tinymce-themes": "static-1.56936",
  "ui-addon-emoji-picker": "static-1.10118",
  "ui-addon-sales-email": "static-1.5445",
  "ui-brand-identity-lib": "static-1.16160",
  "bender-build-tools": "static-1.3357",
  "hub-http-shared-msw-handlers": "static-1.10498",
  "hubspotter-http-shared-msw-handlers": "static-1.10496",
  "usage-tracker-session-replay": "static-1.5275",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1187",
  "tanstack-virtual": "static-1.35",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.304",
  "chirp-fetch": "static-1.2119",
  "chatspot-core": "static-1.22549",
  "copilot-toolkit": "static-1.11712",
  "customer-data-objects-ui-components": "static-1.13263",
  "data-fetching-client": "static-1.9889",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4988",
  "ui-addon-video-player": "static-1.8938",
  "ui-coaching-tips": "static-1.29181",
  "usage-tracker": "static-1.7589",
  "cms-field-types": "static-1.5046",
  "content-icons-ui": "static-1.2298",
  "integrations-lib": "static-1.16886",
  "customer-data-objects": "static-1.7917",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1529",
  "apollo-link-hub-http": "static-2.4889",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.94",
  "immerable": "static-1.4383",
  "ui-addon-iframeable": "static-1.9308",
  "video-components-external": "static-1.12014",
  "video-data-lib": "static-1.35672",
  "breeze-artifacts-sdk": "static-1.126",
  "audio-components": "static-1.6251",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29709",
  "FileManagerImages": "static-1.37467",
  "foundations-components-legacy": "static-1.1384",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.73",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9255",
  "urlinator": "static-1.4765",
  "video-components": "static-1.14016",
  "video-embed": "static-1.36506",
  "ts-schema": "static-1.4242",
  "ContentData": "static-1.69096",
  "layout-data-lib": "static-1.10167",
  "react-dnd-compat": "static-1.4847",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1776",
  "external-options-client-types": "static-1.4289",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7125",
  "hs-promise-utils": "static-1.5827",
  "inbound-db-properties-service-client": "static-1.4005",
  "NamespacedHubStyle": "static-2.9213",
  "growth-onboarding-confetti": "static-1.3293",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11378",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5711",
  "magpie-types": "static-1.5171",
  "simple-logging-lib": "static-1.3281",
  "avatar-components": "static-1.2729",
  "customer-data-ui-utilities": "static-1.10058",
  "growth-onboarding-feedback-components": "static-1.6814",
  "flux-actions": "static-1.358",
  "hubspot-apollo-client": "static-1.5109",
  "integrations-error-boundary-lib": "static-1.14301",
  "integrations-tracking-lib": "static-1.5840",
  "laboratory-lib": "static-3.7383",
  "native-integrations-shared-strings": "static-1.8009",
  "redux-observable": "static-1.71",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10494",
  "unified-auth": "static-1.769",
  "breeze-engine-chat-components": "static-1.507",
  "breeze-engine-core": "static-1.807",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.8018",
  "content-media-composition-data-lib": "static-1.13052",
  "content-media-compositions": "static-2.17059",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19313",
  "unified-auth-core-lib": "static-1.1051",
  "social-insights-client-types": "static-1.22675",
  "advanced-menus-core": "static-1.15491",
  "advanced-menus-lib": "static-1.12376",
  "ExportDialog": "static-6.10612",
  "ui-memberships-settings-lib": "static-1.34675",
  "conditional-properties-service-client": "static-1.3961",
  "crm-pipelines-api-client-types": "static-1.4298",
  "fdsr-migration-layer": "static-1.244",
  "framework-builder-read-service-client": "static-1.4169",
  "framework-data-schema-quick-fetch": "static-1.7030",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3855",
  "persist-promise": "static-1.3933",
  "foundations-components-test-utils": "static-1.5842",
  "reactive-lib": "static-1.952",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.568",
  "universal-page-editor-lib": "static-1.3242",
  "adobe-sign-auth-lib": "static-1.317",
  "ads-unified-auth-lib": "static-1.896",
  "google-sheets-integration-lib": "static-1.895",
  "microsoft-drive-integration-lib": "static-1.1041",
  "surveymonkey-integration-lib": "static-1.340",
  "slack-ui-library": "static-1.10627",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3969",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15490",
  "simple-menus-lib": "static-1.17007",
  "crm-record-cards-service-types": "static-1.3743",
  "location-customization-utils-lib": "static-1.9956",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30688",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55188",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8257",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11713",
  "I18n": "/I18n/static-7.1656",
  "quartz": "/quartz/static-1.7342",
  "quartz-config": "/quartz-config/static-1.1120",
  "quartz-core": "/quartz-core/static-1.6561",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.75",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.863",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55175",
  "feedback-utils": "/feedback-utils/static-1.55179",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4697",
  "forms-utils-lib": "/forms-utils-lib/static-1.12995",
  "foundations-assets": "/foundations-assets/static-1.5107",
  "foundations-components": "/foundations-components/static-1.8359",
  "foundations-theming": "/foundations-theming/static-1.4685",
  "hub-http": "/hub-http/static-1.6445",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12020",
  "icons": "/icons/static-2.673",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4080",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16939",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5503",
  "react-virtualized": "/react-virtualized/static-2.103",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tinymce-plugins": "/tinymce-plugins/static-1.58080",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1224",
  "UIComponents": "/UIComponents/static-3.8659",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3563",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3619",
  "quartz-webpack": "/quartz-webpack/static-1.3566",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2401",
  "property-description-translator": "/property-description-translator/static-1.4070",
  "HeadJS": "/HeadJS/static-2.786",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3368",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4550",
  "jasmine-runner": "/jasmine-runner/static-1.6680",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.864",
  "hubspotter-http": "/hubspotter-http/static-1.4812",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.561",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1017",
  "quartz-head": "/quartz-head/static-1.1007",
  "quartz-i18n": "/quartz-i18n/static-1.1017",
  "quartz-routing": "/quartz-routing/static-1.772",
  "quartz-test": "/quartz-test/static-1.1017",
  "quartz-tracking": "/quartz-tracking/static-1.721",
  "trellis-components": "/trellis-components/static-1.2438",
  "ui-fonts": "/ui-fonts/static-1.975",
  "usage-tracker-container": "/usage-tracker-container/static-1.7579",
  "usage-tracker-core": "/usage-tracker-core/static-1.7439",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7481",
  "reference-resolvers": "/reference-resolvers/static-1.8414",
  "sanitize-text": "/sanitize-text/static-1.8381",
  "PatternValidationJS": "/PatternValidationJS/static-1.3128",
  "ReduxMessenger": "/ReduxMessenger/static-2.10597",
  "sanitize": "/sanitize/static-1.4708",
  "outpost": "/outpost/static-1.4394",
  "rpc-client-utils": "/rpc-client-utils/static-1.4894",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4628",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9658",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.56",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2419",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3168",
  "foundations-theming-base": "/foundations-theming-base/static-1.3670",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.244",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.10",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9546",
  "atom": "/atom/static-1.5308",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8109",
  "ContentUtils": "/ContentUtils/static-1.69021",
  "data-token-picker": "/data-token-picker/static-1.16793",
  "file-manager-components": "/file-manager-components/static-1.24316",
  "FileManagerCore": "/FileManagerCore/static-1.39815",
  "FileManagerLib": "/FileManagerLib/static-1.39956",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8160",
  "hub-http-contrib": "/hub-http-contrib/static-1.3271",
  "interframe": "/interframe/static-3.4987",
  "layout-dnd-components": "/layout-dnd-components/static-1.12867",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11842",
  "property-translator": "/property-translator/static-1.5626",
  "react-codemirror": "/react-codemirror/static-1.10872",
  "react-colorpicker": "/react-colorpicker/static-2.10439",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8331",
  "rich-text-lib": "/rich-text-lib/static-1.20212",
  "tinymce-data": "/tinymce-data/static-1.41051",
  "tinymce-themes": "/tinymce-themes/static-1.56936",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10118",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5445",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16160",
  "bender-build-tools": "/bender-build-tools/static-1.3357",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10498",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10496",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5275",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1187",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.304",
  "chirp-fetch": "/chirp-fetch/static-1.2119",
  "chatspot-core": "/chatspot-core/static-1.22549",
  "copilot-toolkit": "/copilot-toolkit/static-1.11712",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13263",
  "data-fetching-client": "/data-fetching-client/static-1.9889",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4988",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8938",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29181",
  "usage-tracker": "/usage-tracker/static-1.7589",
  "cms-field-types": "/cms-field-types/static-1.5046",
  "content-icons-ui": "/content-icons-ui/static-1.2298",
  "integrations-lib": "/integrations-lib/static-1.16886",
  "customer-data-objects": "/customer-data-objects/static-1.7917",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1529",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4889",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4383",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9308",
  "video-components-external": "/video-components-external/static-1.12014",
  "video-data-lib": "/video-data-lib/static-1.35672",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.126",
  "audio-components": "/audio-components/static-1.6251",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29709",
  "FileManagerImages": "/FileManagerImages/static-1.37467",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1384",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.73",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9255",
  "urlinator": "/urlinator/static-1.4765",
  "video-components": "/video-components/static-1.14016",
  "video-embed": "/video-embed/static-1.36506",
  "ts-schema": "/ts-schema/static-1.4242",
  "ContentData": "/ContentData/static-1.69096",
  "layout-data-lib": "/layout-data-lib/static-1.10167",
  "react-dnd-compat": "/react-dnd-compat/static-1.4847",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1776",
  "external-options-client-types": "/external-options-client-types/static-1.4289",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7125",
  "hs-promise-utils": "/hs-promise-utils/static-1.5827",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4005",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9213",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3293",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11378",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5711",
  "magpie-types": "/magpie-types/static-1.5171",
  "simple-logging-lib": "/simple-logging-lib/static-1.3281",
  "avatar-components": "/avatar-components/static-1.2729",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10058",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6814",
  "flux-actions": "/flux-actions/static-1.358",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5109",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14301",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5840",
  "laboratory-lib": "/laboratory-lib/static-3.7383",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8009",
  "redux-observable": "/redux-observable/static-1.71",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10494",
  "unified-auth": "/unified-auth/static-1.769",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.507",
  "breeze-engine-core": "/breeze-engine-core/static-1.807",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.8018",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13052",
  "content-media-compositions": "/content-media-compositions/static-2.17059",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19313",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1051",
  "social-insights-client-types": "/social-insights-client-types/static-1.22675",
  "advanced-menus-core": "/advanced-menus-core/static-1.15491",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12376",
  "ExportDialog": "/ExportDialog/static-6.10612",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34675",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3961",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4298",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.244",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4169",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7030",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3855",
  "persist-promise": "/persist-promise/static-1.3933",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5842",
  "reactive-lib": "/reactive-lib/static-1.952",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.568",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3242",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.317",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.896",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.895",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1041",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.340",
  "slack-ui-library": "/slack-ui-library/static-1.10627",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3969",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15490",
  "simple-menus-lib": "/simple-menus-lib/static-1.17007",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3743",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9956",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
